"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adamsDimensions = exports.PORTFOLIO_THEME_COLOR = exports.TOS_PRIVACY_TYPE = exports.PORTFOLIO_THEME_FONTFAMILY = exports.PORTFOLIO_THEME_TYPE = void 0;
var PORTFOLIO_THEME_TYPE = {
  THEME: 'theme',
  // static theme template
  SITE: 'site' // real portfolio site

};
exports.PORTFOLIO_THEME_TYPE = PORTFOLIO_THEME_TYPE;
var PORTFOLIO_THEME_FONTFAMILY = {
  ALEO: 'Aleo',
  INTER: 'Inter',
  PT_SERIF: 'PT Serif'
};
exports.PORTFOLIO_THEME_FONTFAMILY = PORTFOLIO_THEME_FONTFAMILY;
var TOS_PRIVACY_TYPE = {
  HIDDEN: 'HIDDEN',
  PX_PROVIDED: 'PX_PROVIDED'
};
exports.TOS_PRIVACY_TYPE = TOS_PRIVACY_TYPE;
var PORTFOLIO_THEME_COLOR = {
  BORDER: 'portfolioBorder',
  ACCENT_ORANGE: 'portfolioAccentOrange',
  ACCENT_GOLD: 'portfolioAccentGold',
  ACCENT_TEAL: 'portfolioAccentTeal',
  ACCENT_BLUE: 'portfolioAccentBlue',
  ACCENT_VIOLET: 'portfolioAccentViolet',
  ACCENT_ASH: 'portfolioAccentAsh',
  ACCENT_MONO: 'portfolioAccentMono'
};
exports.PORTFOLIO_THEME_COLOR = PORTFOLIO_THEME_COLOR;
var adamsDimensions = {
  themeTopNavHeight: '72px',
  desktopFooterOffset: '32px',
  mobileFooterOffset: '48px',
  typeThemeModalTitleHeight: '0px'
};
exports.adamsDimensions = adamsDimensions;